import { registerPlugin } from '@capacitor/core';

const Migration = registerPlugin('Migration');

export default Migration;